<template>
  <ModalDialog
    header-text="Account Renewal Instructions"
    :open="true"
    @close-modal="closeModal"
  >
    <template v-slot:content>
      <div class="renewal-header" v-if="main.companySummary?.CertificationEnds">
        Your account is up for renewal on
        {{
          new Date(main.companySummary.CertificationEnds).toLocaleDateString(
            "en-US"
          )
        }}
      </div>
      <div>
        Please take the following steps to ensure a timely and accurate update
        to your Company's Certification Status. Review and submit necessary
        modifications to:
        <ul>
          <li>Schedule A - Ingredient Listing</li>
          <li>Schedule B - Product Listing</li>
          <li>Company contact information</li>
          <li>Financial Overview/outstanding invoices</li>
        </ul>
        Modifications should be submitted online.<br />
        Alternatively, you can download Excel formats of the Schedule A and B,
        enter modifications and forward to your Rabbinic Coordinator.
        <br /><br />
        Certification Invoice should be paid before renewal.
      </div>
    </template>
  </ModalDialog>
</template>

<script setup lang="ts">
import { useMainStore } from "@/stores/useMainStore";
import ModalDialog from "@/shared/ui/modal/ModalDialog.vue";

const main = useMainStore();

const emit = defineEmits<{
  (e: "closeModal"): void;
}>();

function closeModal() {
  emit("closeModal");
}
</script>

<style scoped>
.renewal-header {
  background: #efefef;
  padding: 5px;
  font-size: 16px;
  font-weight: bold;
  margin: 10px 10px 10px;
}
</style>
